/**
 * Meta Pixel (Facebook Pixel).
 */
export const META_PIXEL_ID = '950420514112134'

interface FbqWindow extends Window {
  fbq?: ((...args: unknown[]) => void) & {
    callMethod?: (...args: unknown[]) => void
    queue?: unknown[]
    push?: unknown
    loaded?: boolean
    version?: string
  }
  _fbq?: unknown
}

const SCRIPT_ID = 'meta-pixel-script'

export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || !pixelId) return

  const w = window as FbqWindow

  if (!w.fbq) {
    const fbq: FbqWindow['fbq'] = function (...args: unknown[]) {
      if (fbq && fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else if (fbq && fbq.queue) {
        fbq.queue.push(args)
      }
    } as NonNullable<FbqWindow['fbq']>

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq

    w.fbq = fbq
    w._fbq = fbq
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  w.fbq?.('init', pixelId)
  w.fbq?.('track', 'PageView')
}

export function trackMetaEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  const w = window as FbqWindow
  w.fbq?.('track', event, params)
}
